import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { BotNav } from "../../components/layout/BotNav";
import { useLogout } from "../../hooks/useLogout";

const MorePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const menuItems = [
    [t("Event"), "/events"],
    [t("Customized travel"), "/my-inquiry"],
    [t("Hotel Inquiry"), "/hotel-inquiry"],
    [t("Ticket check"), "/ticket-check"],
  ];

  const mutation = useLogout();

  const handleLogout = () => {
    mutation.mutate();
  };

  const renderActionBtn = () => {
    if (!localStorage.getItem("token")) return null;

    const actionBtn = [
      {
        title: t("Delete account"),
        className: "text-[#DA3838]",
        onClick: () => navigate("/more/delete-account"),
      },
      {
        title: t("Logout"),
        className: "text-[#007AFF]",
        onClick: () => handleLogout(),
      },
    ];

    return actionBtn.map((btn) => (
      <li
        className="flex items-center justify-between border-b border-gray-200 py-4 last:border-none"
        onClick={btn.onClick}
      >
        <span className={clsx("text-base font-medium", btn.className)}>
          {btn.title}
        </span>
      </li>
    ));
  };

  return (
    <>
      <style>
        {` .ui-footer {
        display: none
      }`}
      </style>
      <div className="relative flex h-[56px] w-full items-center justify-center">
        <h2 className="text-lg font-semibold">{t("More")}</h2>
      </div>
      <div className="flex w-full flex-col px-4">
        {menuItems.map(([item, path], index) => (
          <Link
            to={path}
            key={index}
            className="flex items-center justify-between border-b border-gray-200 py-4 last:border-none"
          >
            <span className="text-base font-medium text-gray-800">{item}</span>
            <ChevronRight className="h-5 w-5 text-gray-400" />
          </Link>
        ))}
        {renderActionBtn()}
      </div>
      <BotNav active="MORE" />
    </>
  );
};

export default MorePage;
